/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request body for bulk stopping bots by group IDs
 * @export
 * @interface BulkStopBotRequest
 */
export interface BulkStopBotRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkStopBotRequest
     */
    groupIds: Array<number>;
}

/**
 * Check if a given object implements the BulkStopBotRequest interface.
 */
export function instanceOfBulkStopBotRequest(value: object): value is BulkStopBotRequest {
    if (!('groupIds' in value) || value['groupIds'] === undefined) return false;
    return true;
}

export function BulkStopBotRequestFromJSON(json: any): BulkStopBotRequest {
    return BulkStopBotRequestFromJSONTyped(json, false);
}

export function BulkStopBotRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkStopBotRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'groupIds': json['group_ids'],
    };
}

export function BulkStopBotRequestToJSON(json: any): BulkStopBotRequest {
    return BulkStopBotRequestToJSONTyped(json, false);
}

export function BulkStopBotRequestToJSONTyped(value?: BulkStopBotRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_ids': value['groupIds'],
    };
}

